var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63376 4.12497C3.78376 4.12497 3.88375 4.02497 3.88375 3.87497V1.125H12.8837V4.62496H13.3837V0.874998C13.3837 0.724999 13.2837 0.625 13.1337 0.625H3.63376C3.60876 0.625 3.58376 0.625 3.55876 0.65H3.53376C3.50876 0.675 3.48376 0.675 3.45876 0.699999L0.458788 3.69997C0.433789 3.72497 0.433789 3.74997 0.408789 3.77497V3.79997C0.408789 3.82497 0.383789 3.84997 0.383789 3.87497V15.6249H0.883784V4.12497H3.63376ZM1.23378 3.62497L2.30877 2.54998L3.38376 1.47499V3.62497H1.23378Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2837 8.00034L8.78372 3.17539C8.68372 3.10039 8.58372 3.10039 8.48373 3.17539L2.15879 7.87534H2.13379V7.90034L1.98379 8.00034C1.90879 8.05034 1.88379 8.12534 1.88379 8.20034V9.12533C1.88379 9.27533 1.98379 9.37533 2.13379 9.37533H2.88378V15.6253H3.38377V9.37533H13.8837V15.6253H14.3837V9.37533H15.1337C15.2837 9.37533 15.3837 9.27533 15.3837 9.12533V8.20034C15.3837 8.12534 15.3587 8.05034 15.2837 8.00034ZM14.8837 8.87533H14.1337H3.13378H2.38378V8.37534H12.3837V7.87534H2.98378L8.63372 3.67539L14.8837 8.32534V8.87533Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13378 5.375H8.13379V5.875H9.13378V5.375Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88376 6.375H7.38379V6.875H9.88376V6.375Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38378 9.875H3.88379V10.375H4.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38378 9.875H4.88379V10.375H5.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38378 9.875H5.88379V10.375H6.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38378 9.875H6.88379V10.375H7.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38378 9.875H7.88379V10.375H8.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38378 9.875H8.88379V10.375H9.38378V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3838 9.875H9.88379V10.375H10.3838V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3838 9.875H10.8838V10.375H11.3838V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3838 9.875H11.8838V10.375H12.3838V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3838 9.875H12.8838V10.375H13.3838V9.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63378 11.375H3.88379V11.875H4.38378V15.625H4.88378V11.875H7.13376V15.625H7.63375V11.875H8.13375V11.375H7.38375H4.63378Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63378 13.375H6.13379V13.875H6.63378V13.375Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8838 11.375H9.38379C9.23379 11.375 9.13379 11.475 9.13379 11.625V14.625H9.63378V13.375H10.8838V14.625H11.3838V13.375H12.6338V14.625H13.1337V11.625C13.1337 11.475 13.0338 11.375 12.8838 11.375ZM9.63378 12.875V11.875H10.8838V12.875H9.63378ZM11.3838 12.875V11.875H12.6338V12.875H11.3838Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1338 1.875H10.6338V2.375H12.1338V1.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1338 2.875H9.88379V3.375H12.1338V2.875Z",
    fill: "#575756",
    stroke: "#575756",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.c989a6162337e5bd4aad3aea6c8e42d8.svg";
export { ForwardRef as ReactComponent };